import { toError } from './parsers/error';
import { get } from '../../utils/utils';
import { generateRequiredOptionParamMessageError } from './utils';
export function initPreferences(settings, http) {
  function validateOptions(options) {
    if (!options.msid) {
      throw new Error(generateRequiredOptionParamMessageError('msid'));
    }
  }
  function buildUrl(msid) {
    return `${settings.recommendedPreferencesApiUrl}/_api/site-preferences/${msid}`;
  }

  /**
   * Gets list of items
   * @param options
   * @returns {Promise}
   * @reject {Error}
   */
  function mediaCategories(options) {
    options = options || {};
    validateOptions(options);
    const params = {
      siteToken: settings.siteMediaToken
    };
    return http.get(buildUrl(options.msid), params, {
      withCredentials: true,
      headers: {
        'x-xsrf-token': settings.xsrfToken
      }
    }).then(response => ({
      ...response,
      data: get(response, 'data.payload.mediaCategories', [])
    })).catch(toError);
  }
  function updateMediaCategories(mediaCategories, options) {
    options = options || {};
    validateOptions(options);
    const params = {
      siteToken: settings.siteMediaToken
    };
    const data = {
      mediaCategories
    };
    return http.put(buildUrl(options.msid), data, params, {
      withCredentials: true,
      headers: {
        'x-xsrf-token': settings.xsrfToken
      }
    }).then(response => ({
      ...response,
      data: null
    })).catch(toError);
  }
  return {
    mediaCategories,
    updateMediaCategories
  };
}